import React, {
  Component,
  MouseEvent,
  ReactNode,
  useEffect,
  useState,
} from "react";
import Dropdown from "react-bootstrap/Dropdown";
import Button from "react-bootstrap/Button";
import { Badge, Form } from "react-bootstrap";
import axios from "axios";
import { useStore } from "../store";
import Card from "react-bootstrap/Card";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  IconDefinition,
  faCalendarDays,
  faUpload,
  faTag,
  faHashtag,
  faChevronDown,
  faChevronUp,
} from "@fortawesome/free-solid-svg-icons";
import { Colors, FontSize } from "../utils/style";
import { useTranslation } from 'react-i18next';


type Prop = {
  title?: string;
  children?: ReactNode;
  width?: string;
  titleHeight?: string;
  icone?: IconDefinition;
  typeX?: string;
  typeY?: string;
  description?: string;
  samples?: string[];
};
function CardComponentLida(props: Prop) {
  const [viewSamples, setViewSamples] = useState(false);
  const { t } = useTranslation("CardSummary");

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        height: "100%",
        width: "100%",
      }}
    >
      <Card
        style={{
          width: "100%",
          backgroundColor: "#e5e4e2",
        }}
      >
        <Card.Body className="text-center">
          {props.title ? (
            <div style={{ display: "flex", alignItems: "centre" }}>
              {/* Icon */}
              <FontAwesomeIcon
                icon={props.icone ? props.icone : faTag}
                size="2x"
                color={Colors.DARK_BLUE}
              />
              <Card.Title
                style={{
                  textAlign: "left",
                  height: props.titleHeight ? props.titleHeight : "",
                  fontSize: FontSize.L,
                  display: "flex",
                  alignItems: "center",
                  paddingLeft: "0.5rem",
                  color: Colors.DARK_BLUE,
                }}
              >
                {props.title}
              </Card.Title>
            </div>
          ) : null}
          {props.typeX && props.typeY && (
            <div
              style={{
                fontSize: FontSize.M,
                textAlign: "left",
              }}
            >
              {props.typeX + " | " + props.typeY}
            </div>
          )}
          {props.description && (
            <div
              style={{
                textAlign: "left",
              }}
            >
              {props.description}
            </div>
          )}

          <div
            className="p-2 mt-2"
            style={{
              display: "flex",
              flexDirection: "column",
              gap: "1rem",
              border: "1px solid",
              borderColor: Colors.DARK_BLUE,
            }}
            onClick={() => setViewSamples(!viewSamples)}
          >
            <div style={{ display: "flex", alignItems: "center", gap: "1rem" }}>
              <FontAwesomeIcon
                icon={!viewSamples ? faChevronDown : faChevronUp}
                size="1x"
                //color="green"
                //style={{ backgroundColor: "red" }}
              />
              <div>
                {t("ViewSamples")}
              </div>
            </div>

            {viewSamples && (
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  flexWrap: "wrap",
                  gap: "0.5rem",
                }}
              >
                {props.samples?.map((s) => (
                  <Badge bg="secondary">{s}</Badge>
                ))}
              </div>
            )}
          </div>

          {props.children ? <> {props.children}</> : null}
        </Card.Body>
      </Card>
    </div>
  );
}

export default CardComponentLida;
